function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M10.8 1.06c.22.13.4.32.54.55l8.44 14.33c.44.75.2 1.72-.54 2.17-.25.15-.52.22-.8.22H1.56c-.86 0-1.56-.7-1.56-1.58 0-.29.08-.57.22-.81L8.66 1.6a1.55 1.55 0 012.14-.55zM10 13.33c-.7 0-1.25.58-1.25 1.26 0 .67.56 1.24 1.24 1.24.69 0 1.26-.57 1.26-1.24 0-.68-.57-1.26-1.26-1.26zm.6-7.5H9.37a.64.64 0 00-.6.55l-.01.12.3 5a.63.63 0 00.54.57l.1.01h.63a.64.64 0 00.62-.48l.02-.1.29-5.04a.63.63 0 00-.53-.62h-.12z"
}));